
import React from 'react';

import {Helmet, useQuery} from 'views/module';

import PlaybooksScene from 'views/scenes/playbooks/Playbooks';

const PlaybooksPage = (props) => {
  const query = useQuery();
  const initialSelectedPlaybookRn = query.selectedPlaybookRn || null;

  return (
    <>
      <Helmet>
        <title>Quilt: Playbooks</title>
      </Helmet>
      <PlaybooksScene
        initialSelectedPlaybookRn={initialSelectedPlaybookRn}
      />
    </>
  );
};

export default PlaybooksPage;
